var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { Icon } from "../../tremor/Icon";
import { Input } from "../../tremor/Input";
import { Button } from "../../tremor/Button";
import { useEffect, useState } from "react";
import { create } from "zustand";
import { useDashboard } from "../../layouts/Dashboard/useDashboard";
import { useBackend } from "../../layouts/Wrapper";
import { Text, Label, Title } from "../../tremor/Text";
import { twMerge } from "tailwind-merge";
import { ChevronLeftIcon, ChevronRightIcon, PaperClipIcon, TrashIcon } from "@heroicons/react/20/solid";
import ChartBase from "../Chart/ChartBase";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../tremor/Tabs";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, } from "../../tremor/Select";
import { Divider } from "../../tremor/Divider";
import { Card } from "../../tremor/Card";
import { toast } from "sonner";
import { useMaxHeight } from "../../lib/useMaxHeight";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
export const useImageWidgetModal = create((set) => ({
    open: false,
    setOpen: (op, wid) => set({ open: op, widget: wid }),
}));
export const ImageWidgetModal = ({}) => {
    var _a;
    const { dashboard, refreshWidgets, tab, widgets } = useDashboard();
    const { backend, adminMode } = useBackend();
    const { open, setOpen, widget } = useImageWidgetModal();
    const { lg, sm } = useMaxHeight();
    const [url, setUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const [imageFill, setImageFill] = useState("fill");
    const [settings, setSettings] = useState({});
    const [activeTab, setActiveTab] = useState("configure");
    const [drilldownWidget, setDrilldownWidget] = useState(null);
    const deleteWidget = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!widget || !backend)
            return;
        toast.promise(() => __awaiter(void 0, void 0, void 0, function* () {
            yield backend.widgets.delete(widget.id);
            refreshWidgets(backend);
            setOpen(false);
        }), {
            loading: "Deleting widget...",
            success: "Widget deleted",
            error: (err) => `Failed to delete widget: ${err.message}`,
        });
    });
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        if (widget) {
            const config = widget.config;
            setUrl(((_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.options) === null || _a === void 0 ? void 0 : _a.plugins) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.url) || "");
            setImageFill(((_f = (_e = (_d = config === null || config === void 0 ? void 0 : config.options) === null || _d === void 0 ? void 0 : _d.plugins) === null || _e === void 0 ? void 0 : _e.image) === null || _f === void 0 ? void 0 : _f.fill) || "fill");
            setSettings(widget.settings || {});
            setDrilldownWidget(widget.drilldown_widget);
        }
        else {
            setImageFill("fill");
            setUrl("");
            setSettings({});
            setDrilldownWidget(null);
        }
    }, [widget]);
    const createWidget = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!dashboard || !backend)
            return;
        setLoading(true);
        let cache = {
            type: "image",
            data: { datasets: [{ data: [], label: "" }] },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    image: { url: url, fill: imageFill },
                },
            },
        };
        if (widget) {
            yield backend.widgets.update(widget.id, {
                title: url,
                code: "",
                config: cache,
                settings: settings,
                drilldown_widget: drilldownWidget,
            });
        }
        else {
            yield backend.widgets.create({
                dashboard: dashboard.id,
                layouts: {
                    lg: {
                        x: 0,
                        y: lg,
                        w: 12,
                        h: 10,
                    },
                    sm: {
                        x: 0,
                        y: sm,
                        w: 3,
                        h: 10,
                    },
                },
                use_in_library: false,
                use_in_chat: false,
                title: url,
                team: dashboard.team,
                code: "",
                messages: [],
                error: null,
                settings: settings,
                tab: tab || 0,
                config: cache,
                engine: "manual-v1",
                type: "image",
                drilldown_widget: drilldownWidget,
            });
        }
        setOpen(false);
        setLoading(false);
        setUrl("");
        refreshWidgets(backend);
    });
    const uploadFile = (e) => __awaiter(void 0, void 0, void 0, function* () {
        toast.promise(() => __awaiter(void 0, void 0, void 0, function* () {
            if (!e.target.files)
                return;
            return backend === null || backend === void 0 ? void 0 : backend.utils.uploadFile(e.target.files[0]);
        }), {
            loading: "Uploading file...",
            success: (res) => {
                setUrl(res.url);
                return "File uploaded";
            },
            error: (err) => {
                return "Failed to upload file: " + err.message;
            },
        });
    });
    if (!((_a = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _a === void 0 ? void 0 : _a.can_create_widgets) && !adminMode)
        return React.createElement(React.Fragment, null);
    return (React.createElement(React.Fragment, null,
        React.createElement("dialog", { open: open },
            React.createElement("div", { className: twMerge("onvo-@container/widgetmodal onvo-h-full onvo-animate-dialogOpen onvo-w-full onvo-z-50 onvo-fixed onvo-left-0 onvo-top-0 onvo-foreground-color") },
                React.createElement("div", { className: "onvo-relative onvo-flex onvo-flex-grow onvo-h-full onvo-w-full" },
                    React.createElement(PanelGroup, { autoSaveId: "edit-widget", direction: "horizontal" },
                        React.createElement(Panel, { minSize: 25 },
                            React.createElement("div", { className: "onvo-foreground-color onvo-w-full onvo-left-0 onvo-top-0 onvo-z-10 onvo-flex onvo-flex-row onvo-justify-start onvo-items-center onvo-gap-4 onvo-border-solid onvo-border-b onvo-border-black/10 onvo-p-2 dark:onvo-border-white/10" },
                                React.createElement(Icon, { icon: ChevronLeftIcon, variant: "shadow", className: "onvo-ml-2 onvo-background-color onvo-border-solid onvo-border onvo-border-black/10 dark:onvo-border-white/10", onClick: () => setOpen(false) }),
                                React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-w-full onvo-gap-1 onvo-flex-grow onvo-justify-start onvo-items-center" },
                                    React.createElement(Text, { className: "onvo-hidden @xl/widgetmodal:onvo-block" }, dashboard === null || dashboard === void 0 ? void 0 : dashboard.title),
                                    React.createElement(ChevronRightIcon, { className: "onvo-hidden @xl/widgetmodal:onvo-block onvo-h-4 onvo-w-4 dark:onvo-fill-slate-500" }),
                                    React.createElement(Label, null, widget ? `Edit image widget` : "Create image widget"))),
                            React.createElement("div", { className: "onvo-h-full onvo-background-color onvo-flex onvo-flex-shrink-0 @xl/widgetmodal:onvo-flex-shrink onvo-flex-col onvo-justify-center onvo-w-full onvo-flex-grow onvo-relative onvo-p-4 onvo-overflow-y-auto onvo-bg-[radial-gradient(#e2e8f0_1px,transparent_1px)] dark:onvo-bg-[radial-gradient(#0f172a_1px,transparent_1px)] [background-size:16px_16px]" },
                                React.createElement("div", { className: "onvo-relative onvo-flex onvo-w-full onvo-flex-col" },
                                    React.createElement(ChartBase, { json: {
                                            type: "image",
                                            data: { datasets: [{ data: [], label: "" }] },
                                            options: {
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                plugins: {
                                                    image: {
                                                        url: url,
                                                        fill: imageFill,
                                                    },
                                                },
                                            },
                                        }, title: "" })))),
                        React.createElement(PanelResizeHandle, { className: "onvo-w-3 onvo-border-0 onvo-transition-all onvo-bg-black/10 dark:onvo-bg-white/10 hover:onvo-bg-black/20 dark:hover:onvo-bg-white/20 active:onvo-bg-black/40 dark:active:onvo-bg-white/40 onvo-flex onvo-justify-center onvo-items-center" },
                            React.createElement("div", { className: "onvo-w-1 onvo-h-12 onvo-rounded-full onvo-bg-black/30 dark:onvo-bg-white/30" })),
                        React.createElement(Panel, { defaultSize: 50, minSize: 25 },
                            React.createElement(Tabs, { defaultValue: "configure", onValueChange: (value) => setActiveTab(value), className: "onvo-flex onvo-flex-col onvo-h-full" },
                                React.createElement(TabsList, null,
                                    React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-pt-5" },
                                        React.createElement(TabsTrigger, { value: "configure" }, "Configure"),
                                        React.createElement(TabsTrigger, { value: "settings" }, "Settings")),
                                    React.createElement("div", { className: "onvo-flex-grow onvo-w-full onvo-h-2" }),
                                    React.createElement(Button, { onClick: createWidget, className: "onvo-flex-shrink-0 onvo-mr-2", isLoading: loading }, widget ? "Save" : "Create")),
                                React.createElement(TabsContent, { value: "configure", className: "onvo-h-full onvo-overflow-y-auto onvo-scrollbar-thin" },
                                    React.createElement("div", { className: "onvo-p-4 onvo-flex onvo-flex-col onvo-justify-start" },
                                        React.createElement(Text, null, "Image URL"),
                                        React.createElement(Input, { placeholder: "Type in a URL", value: url, inputClassName: "onvo-background-color onvo-mt-1 onvo-border-black/10 dark:onvo-border-white/10", onChange: (e) => setUrl(e.target.value) }),
                                        React.createElement(Divider, null,
                                            React.createElement(Text, null, "OR")),
                                        React.createElement(Card, { className: "onvo-background-color onvo-border-black/10 dark:onvo-border-white/10 onvo-relative onvo-flex onvo-h-auto onvo-cursor-pointer onvo-flex-row onvo-items-center onvo-justify-center onvo-py-10" },
                                            React.createElement(Icon, { icon: PaperClipIcon }),
                                            React.createElement("div", { className: "onvo-ml-4 onvo-flex-grow" },
                                                React.createElement(Title, null, "Drag and drop an image here or click to add"),
                                                React.createElement(Text, { className: "onvo-text-xs onvo-italic" }, "Upload .jpeg, .png, .svg files")),
                                            React.createElement("input", { onChange: uploadFile, type: "file", accept: "image/*", className: "onvo-absolute onvo-left-0 onvo-top-0 onvo-z-10 onvo-h-full onvo-w-full onvo-cursor-pointer onvo-opacity-0" })),
                                        React.createElement("div", { className: "onvo-mt-4 onvo-flex onvo-items-center onvo-justify-between" },
                                            React.createElement(Text, null, "Image fill"),
                                            React.createElement(Tabs, { value: imageFill, onValueChange: (val) => {
                                                    setImageFill(val);
                                                } },
                                                React.createElement(TabsList, { variant: "solid" },
                                                    React.createElement(TabsTrigger, { value: "fit" }, "Fit"),
                                                    React.createElement(TabsTrigger, { value: "fill" }, "Fill")))))),
                                React.createElement(TabsContent, { value: "settings", className: "onvo-px-4 onvo-py-2" },
                                    React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-items-center onvo-justify-between onvo-gap-2" },
                                        React.createElement(Text, { className: "onvo-text-sm onvo-w-32 onvo-shrink-0" }, "Widget ID"),
                                        React.createElement(Input, { placeholder: "ID", className: "onvo-text-xs", value: widget === null || widget === void 0 ? void 0 : widget.id, disabled: true, inputClassName: "onvo-background-color onvo-border-black/10 dark:onvo-border-white/10" })),
                                    React.createElement(Divider, null),
                                    React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-items-center onvo-justify-between onvo-gap-2 onvo-mt-2" },
                                        React.createElement(Text, { className: "onvo-text-sm onvo-w-32 onvo-shrink-0" }, "CSS ID"),
                                        React.createElement(Input, { placeholder: "id", className: "onvo-text-xs", value: settings === null || settings === void 0 ? void 0 : settings.css_id, onChange: (e) => setSettings(Object.assign(Object.assign({}, settings), { css_id: e.target.value })), inputClassName: "onvo-background-color onvo-border-black/10 dark:onvo-border-white/10" })),
                                    React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-items-center onvo-justify-between onvo-gap-2 onvo-mt-2" },
                                        React.createElement(Text, { className: "onvo-text-sm onvo-w-32 onvo-shrink-0" }, "CSS classes"),
                                        React.createElement(Input, { placeholder: "class-name", className: "onvo-text-xs", value: settings === null || settings === void 0 ? void 0 : settings.css_classnames, onChange: (e) => setSettings(Object.assign(Object.assign({}, settings), { css_classnames: e.target.value })), inputClassName: "onvo-background-color onvo-border-black/10 dark:onvo-border-white/10" })),
                                    React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-items-center onvo-justify-between onvo-gap-2 onvo-mt-2" },
                                        React.createElement(Text, { className: "onvo-text-sm onvo-w-32 onvo-shrink-0" }, "Link"),
                                        React.createElement(Input, { placeholder: "https://...", className: "onvo-text-xs", value: settings === null || settings === void 0 ? void 0 : settings.link, onChange: (e) => setSettings(Object.assign(Object.assign({}, settings), { link: e.target.value })), inputClassName: "onvo-background-color onvo-border-black/10 dark:onvo-border-white/10" })),
                                    React.createElement(Divider, null),
                                    React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-items-center onvo-justify-between onvo-gap-2" },
                                        React.createElement(Text, { className: "onvo-text-sm onvo-w-32 onvo-shrink-0" }, "Drilldown widget"),
                                        React.createElement(Select, { value: drilldownWidget || undefined, onValueChange: (val) => {
                                                setDrilldownWidget(val);
                                            } },
                                            React.createElement(SelectTrigger, null,
                                                React.createElement(SelectValue, { placeholder: "None" })),
                                            React.createElement(SelectContent, null, widgets
                                                .filter((item) => item.id !== (widget === null || widget === void 0 ? void 0 : widget.id) &&
                                                [
                                                    "divider"
                                                ].indexOf((widget === null || widget === void 0 ? void 0 : widget.type) || "") === -1 &&
                                                item.title.trim() !== "")
                                                .map((item) => (React.createElement(SelectItem, { key: item.id, value: item.id }, item.title)))))),
                                    React.createElement(Divider, null),
                                    React.createElement(Button, { variant: "destructive", onClick: deleteWidget, className: "onvo-w-full onvo-mt-2" },
                                        React.createElement(TrashIcon, { className: "onvo-h-4 onvo-w-4 onvo-mr-2" }),
                                        "Delete widget"))))))))));
};
//# sourceMappingURL=ImageWidgetModal.js.map